<app-loader *ngIf="loading"></app-loader>
<iframe #legacyIframe [src]="(url || '') | sanitize: 'resourceUrl'"  id="legacy" [style.height]="height"></iframe>

